import PageDiverged from '../../../assets/images/layout-builder/diverged.png'

export const PageDivergedIcon = () => {
  return <img src={PageDiverged} alt='PageLocked' width='25px' height='25px' />
}
